export default {"src":"/_next/static/media/success.32e1a390.svg","height":211,"width":220};